import { EChartPeriod } from '@aqx-core/common/api/chart';
import { EMainProductCodeType } from '@aqx-core/common/api/config';

export const basePeriods = [
  EChartPeriod.PERIOD_M1,
  EChartPeriod.PERIOD_M5,
  EChartPeriod.PERIOD_M15,
  EChartPeriod.PERIOD_M30,
  EChartPeriod.PERIOD_H1,
  EChartPeriod.PERIOD_H4,
  EChartPeriod.PERIOD_D1,
  EChartPeriod.PERIOD_W1,
  EChartPeriod.PERIOD_MN1
];

export const horizonExcludePeriods = [EChartPeriod.PERIOD_H4, EChartPeriod.PERIOD_MN1];

export const interactableExtendPeriods = {
  [EMainProductCodeType.METATRADER5]: [
    ...basePeriods,
    EChartPeriod.PERIOD_M2,
    EChartPeriod.PERIOD_M3,
    EChartPeriod.PERIOD_M4,
    EChartPeriod.PERIOD_M6,
    EChartPeriod.PERIOD_M10,
    EChartPeriod.PERIOD_M20,
    EChartPeriod.PERIOD_H2,
    EChartPeriod.PERIOD_H3,
    EChartPeriod.PERIOD_H6
  ],
  [EMainProductCodeType.COMPANY]: undefined,
  [EMainProductCodeType.METATRADER4]: undefined,
  [EMainProductCodeType.FTX]: undefined,
  [EMainProductCodeType.HORIZON]: undefined,
  [EMainProductCodeType.CENTROID]: undefined,
  [EMainProductCodeType.GENERIC]: undefined
};
